const initHoverMedia = (wrapper) => {
    const triggers = wrapper.querySelectorAll('.js-hover-media-trigger');
    const targets = wrapper.querySelectorAll('.js-hover-media-target');

    // Check if triggers & targets exist
    if ((triggers && triggers.length > 1) && (targets && targets.length > 1)) {
        // Loop over and attach listeners
        triggers.forEach((trigger) => {
            // Show relevant image on hover
            trigger.addEventListener('mouseenter', () => {
                const count = trigger.dataset.imageCount;

                targets.forEach((element) => {
                    element.classList.remove('active');
                });

                if (targets[count]) {
                    targets[count].classList.add('active');
                }
            });

            // Hide all on mouse leave
            trigger.addEventListener('mouseleave', () => {
                targets.forEach((element) => {
                    element.classList.remove('active');
                });
            });
        });
    }
};

export { initHoverMedia as default };
